import React, { PropTypes } from 'react';
import SharedTools from '../../lib/SharedTools';
import DataService from '../../lib/DataService';
import { ObservationComponent }  from "./commonComponent/ObservationComponent";
import { ObservationDetail } from "./commonComponent/ObservationDetail";
import ObservationParagraph from "./commonComponent/ObservationParagraph";
import { message, Spin, Select, Modal, Input, Button, Icon, DatePicker } from "antd";
import { hashHistory } from 'react-router';
import moment from 'moment';

const Option = Select.Option;
const { TextArea } = Input;
export default class ObservationIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    let currentSemester = SharedTools.getCurrentSemester()
    let semesters = SharedTools.getAllSemesters(currentSemester, 20201);
    this.state = {
      semester: props.location.query.semester ? props.location.query.semester : currentSemester,
      classId: props.params.classId ? props.params.classId : 0,
      records: [],
      loading: false,
      isBottom: false,
      semesters,
      visibility:"请选择学生...",
      editModalVisible:false,
      studentsModalVisible:false,
      editRecord:null,
      paragraphKeys:[],
      isCreate:true,
      students:[],//学生是否选择信息
      student_records:[],//全部学生信息
      confirmedVisiblity: [],
      allStudentsChecked: false,
      allStudentsCheckedConfirmed: false,
    };
    // bind this
    this.onAllStudentsChecked = this.onAllStudentsChecked.bind(this);
    this.handleVisibilityOk = this.handleVisibilityOk.bind(this);
    this.handleVisibilityCancel = this.handleVisibilityCancel.bind(this);
    this.showStudentsModal = this.showStudentsModal.bind(this);
    this.selectDate = this.selectDate.bind(this)
    this.onAddSegment = this.onAddSegment.bind(this)
  }

  componentDidMount() {
    this.getDevelopmentRecords()
    this.getStudentsInfo()
  }

  toolData(data) {
    let arr = data.filter((post) => post.id).sort(function (x, y) {
      if (x.id > y.id) {
        return -1;
      } else {
        return 1;
      }
    })
    return arr;
  }

  // 观察记录
  getDevelopmentRecords() {
    this.setState({
      loading: true
    })
    let data = {
      semester: this.state.semester,
      class_record_id: this.state.classId
    }
    this.state.to_id ? data.to_id = this.state.to_id : undefined;

    DataService.getDevelopmentRecords(data).then((res) => {
      let records = this.state.records.concat(this.toolData(res))
      let to_id = records.length > 0 ? records[records.length - 1].id : undefined;
      this.setState({
        records,
        loading: false,
        to_id,
        isBottom: res.length < 10 ? true : false
      })
    }).catch((error) => {
      console.log(error)
      message.error('请求出错！')
      this.setState({
        loading: false
      })
    });
  }

  getStudentsInfo(){
    DataService.getAllStudents(this.state.classId).then((res)=>{
      let students = res.map((student,index) => {
        return ({
          checked: false,
          index:index,
          studentName: student.full_name,
          studentId: student.id
        });
      })
      this.setState({
        students: students,
        student_records:res,
        confirmedVisiblity: students.map(s => {return ({checked: s.checked})}),
        allStudentsChecked: false,
        allStudentsCheckedConfirmed: false,
        visibility: "请选择学生...",
      })
    }).catch((error) => {
      console.log(error)
      message.error('请求出错！')
      this.setState({
        loading: false
      })
    });
  }
  
  goObservationStudentsListPage(e, record) {
    hashHistory.push(`development/observation-record/classes/${this.state.classId}/observations/${record.id}?semester=${this.state.semester}`)
    e.stopPropagation()
  }

  goObservationDetail(record) {
    DataService.getObservationDetail(record.id).then((res) => {
      this.setState({
        observation: res,
      })
    }).catch((error) => {
      console.log(error);
    });
  }

  goDeleteObservationRecord(record){
    let that = this;
    let {records} = this.state
    Modal.confirm({
      title: '是否确认删除当前记录?',
      content: '如果删除将无法恢复',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        DataService.destroyObservationRecord(record.id).then((res)=>{
          message.success('删除成功！');
          const newRecords = records.filter(r => r !== record);
          that.setState({
            records:newRecords
          })
        }).catch((err)=>{
          console.log(err)
          message.error('删除失败！');
        })
      },
    });
  }

  onDeleteParagraph = (index) => {
    let that = this;
    let {editRecord,paragraphKeys} = this.state
    Modal.confirm({
      title: '是否确认删除该段落?',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        const segments = editRecord.segments_info.filter(s => s.index!==index).map((segment, index) => ({ ...segment, index: index + 1 }));
        paragraphKeys.splice(index-1,1)
        editRecord.segments_info  = segments
        that.setState({
          editRecord,
          paragraphKeys
        })
      },
    });
  }

  editHandleOk = (e) => {
    let that = this;
    if(this.state.editRecord.student_count===0||this.state.editRecord.segments_info.length===0||this.state.editRecord.record_date===""){
      Modal.warning({
        title: '有未添加的记录',
        content: '请确认您的所有记录信息填写完整',
      });
      return
    }
    let {records,editRecord,isCreate} = this.state
    let editRecordIndex = records.findIndex( record=> record.id === editRecord.id);
    let timeStamp = editRecord.record_date || parseInt(Date.now() / 1000);
    if(isCreate){
      let data = {
        record_date:timeStamp,
        class_record_id:editRecord.class_record_id,
        student_ids:editRecord.students.map(s=>s.id),
        segments:editRecord.segments_info,
        semester:editRecord.semester
      }
      DataService.createObservationRecord(data).then((res)=>{
        message.success('新建成功！')
        records.unshift(res)
        that.setState({
          editModalVisible: false,
          editRecord:null,
          paragraphKeys:[],
          records
        })
      }).catch((error) => {
        console.log(error)
        message.error('新增失败！')
      });
      
    }
    else{
      let data = {
        id:editRecord.id,
        student_ids:editRecord.students.map(s=>s.id),
        segments:editRecord.segments_info,
        record_date:timeStamp,
      }
      DataService.updateObservationRecord(data).then((res)=>{
        message.success('编辑成功！')
        
        // 创建新的editRecord，转换record_date格式以匹配列表页面的显示需求
        let updatedRecord = {...editRecord}
        if (updatedRecord.record_date && typeof updatedRecord.record_date === 'number') {
          // 将时间戳转换为datetime字符串，保持与后端返回格式一致
          updatedRecord.record_date = new Date(updatedRecord.record_date * 1000).toISOString()
        }
        
        records[editRecordIndex] = updatedRecord
        that.setState({
          editModalVisible: false,
          editRecord:null,
          paragraphKeys:[],
          records
        })
      }).catch((error) => {
        console.log(error)
        message.error('编辑失败！')
      });
    }
  }
  editHandleCancel = (e) => {
    this.setState({
      editModalVisible: false,
      editRecord:null,
      paragraphKeys:[]
    })
  }

  goEditObservationRecord(record){
    let editRecord
    let {students,allStudentsChecked,allStudentsCheckedConfirmed,visibility,paragraphKeys,semester,classId,isCreate} = this.state
    if(record){
      editRecord = JSON.parse(JSON.stringify(record))
      if(editRecord){
        if(editRecord.students.length < students.length){
          students.map(student => student.checked = editRecord.students.find(s => s.id === student.studentId)?true:false)
          visibility = this.state.students.filter(s => s.checked).map(s => s.studentName).join("、");
          allStudentsChecked = false
          allStudentsCheckedConfirmed = false
        }
        paragraphKeys = editRecord.segments_info.map((s,index) => {return (Date.now().toString()+index.toString())})
      }
      isCreate = false
    }
    else{
      editRecord = {
        record_date:null,
        class_record_id:classId,
        complete_students:[],
        complete:false,
        complete_count:0,
        students:[],
        student_count:0,
        segments_info:[],
        semester:semester
      }
      isCreate = true
    }
    this.setState({
      editRecord,
      paragraphKeys,
      students,
      editModalVisible:true,
      visibility,
      allStudentsChecked,
      allStudentsCheckedConfirmed,
      isCreate,
    })
  }


  handleVisibilityOk() {
    let confirmedVisiblity = this.state.students.map(s => {return ({checked: s.checked})});

    let {editRecord} = this.state
    let visibility = ""

    if (this.state.allStudentsChecked) {
      visibility = "全班";
    } else {
      visibility = this.state.students.filter(s => s.checked).map(s => s.studentName).join("、");
    }

    if (visibility == "") {
      visibility = "请选择学生...";
    }

    let students = []
    this.state.students.map(student=>{
      if(student.checked){
        students.push(this.state.student_records[student.index])
      }
    })
    editRecord.students = students
    editRecord.student_count = students.length
    this.setState({
      visibility: visibility,
      editRecord,
      studentsModalVisible: false,
      students: this.state.students,
      confirmedVisiblity: confirmedVisiblity,
      allStudentsCheckedConfirmed: this.state.allStudentsChecked,
    })
  }

  handleVisibilityCancel() {
    this.state.students.forEach((s, index) => {
      s.checked = this.state.confirmedVisiblity[index].checked;
    });
    this.setState({
      studentsModalVisible: false,
      students: this.state.students,
      allStudentsChecked: this.state.allStudentsCheckedConfirmed,
    });
  }

  showStudentsModal() {
    this.setState({
      studentsModalVisible: true
    })
  }

  onStudentChecked(studentId) {
    let student = this.state.students.find(s => s.studentId == studentId)
    if (!student) {
      return;
    }

    if(student.checked){
      student.checked = false;
    }
    else{
      student.checked = true;
    }

    this.setState({
      students: this.state.students,
      allStudentsChecked: this.state.students.filter(s => s.checked).length == this.state.students.length
    })
  }

  onAllStudentsChecked() {
    if (this.state.allStudentsChecked) {
      this.state.students.forEach(s => {
        s.checked = false;
      })
      this.setState({
        students: this.state.students,
        allStudentsChecked: false
      })
    } else {
      this.state.students.forEach(s => {
        s.checked = true;
      })
      this.setState({
        students: this.state.students,
        allStudentsChecked: true
      })
    }
  }

  handleImgUrlChange = (value,index) => {
    let newEditRecord = this.state.editRecord
    let indexToUpdate = newEditRecord.segments_info.findIndex(segment => segment.index === index);
    if (indexToUpdate !== -1) {
      newEditRecord.segments_info[indexToUpdate].image_url = value
    }
    this.setState({
      editRecord:newEditRecord
    })

  };

  handleParagraphChange = (value,index) => {
    let newEditRecord = this.state.editRecord
    let indexToUpdate = newEditRecord.segments_info.findIndex(segment => segment.index === index);
    if (indexToUpdate !== -1) {
      newEditRecord.segments_info[indexToUpdate].text = value
    }
    this.setState({
      editRecord:newEditRecord
    })
  };

  onAddSegment(){
    const {editRecord,paragraphKeys} = this.state
    const newSegment = {
      index:editRecord.segments_info.length+1,
      image_url:null,
      text:""
    }
    paragraphKeys.push(Date.now().toString()+(paragraphKeys.length).toString())
    editRecord.segments_info.push(newSegment)
    this.setState({
      editRecord,
      paragraphKeys,
    })
  }

  selectDate(date){
    // 处理null值
    if (!date) {
      let newEditRecord = this.state.editRecord
      newEditRecord.record_date = null
      this.setState({
        editRecord: newEditRecord
      })
      return
    }
    
    // 处理moment对象（Antd DatePicker传递的是moment对象）
    const timeStamp = parseInt(date.valueOf() / 1000);  // 或者 date.unix()
    let newEditRecord = this.state.editRecord
    newEditRecord.record_date = timeStamp
    this.setState({
      editRecord: newEditRecord
    })
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        this.setState({
          records: [],
          loading: false,
          to_id: undefined,
          isBottom: false
        })
        this.componentDidMount()
      })
    }
  }

  _checkCircleIcon(checked, onClick) {
    if (checked) {
      return (<Icon className={checked ? "checked" : ""} onClick={onClick} type="check-circle" />);
    } else {
      return (<Icon className={checked ? "checked" : ""} onClick={onClick} type="check-circle-o" />);
    }
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  _editObservationRecordBox(){
    let {isCreate} = this.state
    return(
      <Modal
      wrapClassName="observations-edit-paragraph-modal"
      title={isCreate?'新增':"编辑"}
      visible={this.state.editModalVisible}
      onOk={this.editHandleOk}
      onCancel={this.editHandleCancel}
      okText='确认'
      cancelText='取消'
    >
      <div style={{ display: 'flex', alignItems: 'center', minHeight: '20px' }}>
        <span>发送给谁：</span>
        <Input style={{ width: '300px' }} value={this.state.visibility} onClick={this.showStudentsModal} />
        <span>&nbsp;&nbsp;已选{this.state.students.filter(student => student.checked).length}人</span>
      </div>
      <br/>
      <div style={{ display: 'flex', alignItems: 'center', minHeight: '20px' }}>
        <span>记录时间：</span>
        <DatePicker label="Top coders" value={this.state.editRecord && this.state.editRecord.record_date ? 
          (typeof this.state.editRecord.record_date === 'string' ? 
            moment(this.state.editRecord.record_date) : 
            moment.unix(this.state.editRecord.record_date)
          ) : null} onChange={this.selectDate} placeholder="请选择日期"/>
      </div>
      <div className='observation-paragraphs-container'>
        {this.state.editRecord?this.state.editRecord.segments_info.map((segment,index) => <ObservationParagraph key={this.state.paragraphKeys[index]} img_url={segment.image_url}  paragraph={segment.text} index={segment.index} onImgUrlChange={this.handleImgUrlChange} onParagraphChange={this.handleParagraphChange} goDeleteParagraph={this.onDeleteParagraph}/>) :null}
      </div>
      <span className="add-card-btn" onClick={this.onAddSegment}>+添加段落</span>
    </Modal>
    )
  }

  _selectStudentsModal() {
    return (
      <Modal wrapClassName="notifications-select-students-modal" visible={this.state.studentsModalVisible} onCancel={this.handleVisibilityCancel} maskClosable={false} footer={[
        <Button className="confirm-visibility-button" type="primary" key="confirm" onClick={this.handleVisibilityOk}>确认学生</Button>
      ]}>
        <div className="selected-students-count">已选{this.state.students.filter(student => student.checked).length}人</div>
        <div className={"all-students-check-box" + (this.state.allStudentsChecked ? " checked" : "")}>
          {this._checkCircleIcon(this.state.allStudentsChecked, this.onAllStudentsChecked)}
          <div className="all-students-label">全班</div>
        </div>
        <div className="students-check-box">
          <div className="students-container">
          {this.state.students.map(student =>
            <div className={"student-name" + (student.checked ? " checked" : "")} key={student.studentId} onClick={this.onStudentChecked.bind(this, student.studentId)}>{student.studentName}</div>
          )}
          </div>
        </div>
      </Modal>
    )
  }

  render() {
    let { records, isBottom, observation, loading, studentId} = this.state;
    return (
      <div className="observatio-index-page archive-content-setting-class-page">
        {this._selectSemesterBox()}
        {this._editObservationRecordBox()}
        {this._selectStudentsModal()}
        <Button type="primary" size="large" className='add-observation-btn' onClick={this.goEditObservationRecord.bind(this,null)} >+新增观察记录</Button>
        {records.map(item => <ObservationComponent
                                          record={item}
                                          key={item.id}
                                          goObservationStudentsListPage={this.goObservationStudentsListPage.bind(this)}
                                          goObservationDetail={this.goObservationDetail.bind(this)}
                                          goDeleteObservationRecord={this.goDeleteObservationRecord.bind(this)}
                                          goEditObservationRecord={this.goEditObservationRecord.bind(this)}
                                          showCount={studentId ? false : true}
                                        />)}
                                        
        {!isBottom ? 
          <div onClick={() => this.getDevelopmentRecords()} className="more-btn">
            {!loading ? '点击加载更多' : <Spin /> }
          </div> : ''}
        <ObservationDetail
            segments={observation ? observation.segments_info : []}
            visible={observation ? true : false}
            handleCancel={() => { this.setState({ observation: null})}}
            />
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/ObservationIndexPage.jsx